import { createSelector } from "reselect";

const getConfigurationStore = (state) => state.configuration;

export const getConfigStore = createSelector(getConfigurationStore, (configuration) => configuration.config);

export const fetchConfigEnded = createSelector(getConfigurationStore, (configuration) => configuration.fetchEnded);

export const isMobileMode = createSelector(getConfigurationStore, (configuration) => configuration.mobileMode);
